import styled, { css } from "styled-components";
import { trueBlue } from "../../utils/StyleHelpers";
import brandLogo from "../../assets/logos/brandLogo.svg";

export const StyledTopAppBar = styled.div`
  position: fixed;
  width: 100%;
  background: ${trueBlue};
  z-index: 1299;
`;

export const StyledTopAppBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1.44rem 2.5rem;
  height: 3.37rem;
  z-index: 1299;
`;

export const StyledBrandLogo = styled.div`
  width: 19.4375rem;
  height: 3.375rem;
  flex-shrink: 0;
  background: url(${brandLogo}) 50% / cover no-repeat;
`;

export const StyledNav = styled.ul`
  list-style: none;
`;

export const StyledNavItem = styled.li`
  display: inline-block;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1.8rem;
  padding-bottom: 1.95rem;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const StyledNavLink = styled.a<any>`
  text-decoration: none;
  color: #fff;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${(props) =>
    props.isactive === "true"
      ? css`
          border-bottom: 0.5rem solid #fff;
          padding-bottom: 1.85rem;
        `
      : css`
          border-bottom: 0.5rem solid transparent;
          padding-bottom: 1.85rem;
        `}
`;

export const StyledLogoutButton = styled.button`
  display: inline-flex;
  padding: 1rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const StyledPageTitle = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #fff;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledButton = styled.button<any>`
  display: flex;
  width: 12.5rem;
  padding: 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  cursor: pointer;
  background: ${(props) =>
    props?.background ? props?.background : "rgba(255, 255, 255, 1)"};
  &:hover {
    background: ${(props) =>
      props?.backgroundHovered
        ? props?.backgroundHovered
        : "rgba(255, 255, 255, 0.8)"};
  }
`;

export const StyledButtonList = styled.ul`
  list-style: none;
`;

export const StyledButtonItem = styled.li`
  display: inline-block;
  padding-left: 1rem;
  padding-right: 1rem;
`;
